module.exports = __webpack_public_path__ + "img/s7Model5M.b82bca35.webp";